var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-google-play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download-Copy",
    transform: "translate(-721.000000, -624.000000)",
    fill: "#0FA44A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HERO",
    transform: "translate(-546.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email-Form",
    transform: "translate(948.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-copy-3",
    transform: "translate(271.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(48.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.79399148,29.0495828 C3.31304617,28.9200358 3,28.4425425 3,27.7036435 L3,3.31367048 C3,2.6293373 3.26506078,2.16780444 3.68523332,2 L3.68523332,2 L15.6709681,15.5921854 L3.79399148,29.0495828 L3.79399148,29.0495828 Z M5.44391401,28.5318619 L19.8709561,20.3550987 L16.3570449,16.3702172 L5.44391401,28.5318619 L5.44391401,28.5318619 Z M19.970302,10.7207567 L5.74431628,2.65607152 L16.3778467,14.7912453 L19.970302,10.7207567 L19.970302,10.7207567 Z M20.9355235,11.267939 L26.5084814,14.4272386 C27.5636542,15.0254141 27.5733039,15.9896665 26.5084814,16.5931722 L20.7945332,19.8316462 L17.0675855,15.5783874 L20.9355235,11.267939 L20.9355235,11.267939 Z",
    id: "google-play"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGooglePlay);
export default __webpack_public_path__ + "static/media/ic-google-play.d6a81738e63165a261e90c4298053b4c.svg";
export { ForwardRef as ReactComponent };